<template>
  <div class="header">
    <h2 class="header_title">
      {{title}}
    </h2>
    <img class="list" src="../assets/image/studios_list.png" @click="showMenu">
    <div class="user">
      <div class="avatar">
        <img v-if="avatar != ''"  :src="avatar" >
        <img v-else src="../assets/image/avatar.png" >
        <span>{{username}}</span>
      </div>
      <ul class="user_infor">
        <li @click="goCenter">
          <img src="../assets/image/user_center_icon.png"><span>个人中心</span>
        </li>
        <li @click="signOut">
          <img src="../assets/image/sign_out.png"><span>退出</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { title } from '../config/index'
export default {
  name: '',
  data(){
    return {
      isCollapse:false,
      title
    }
  },
  props: {
    username:{
      type:String,
      default:""
    },
     avatar:{
      type:String,
      default:""
    },
  },
  created(){
    console.log(title)
  },
  mounted(){},
  methods:{
    
    signOut(){
      this.$store.commit('deleInfo')
      this.$store.commit('deleteConfig')
      this.$store.commit('deleteRouters')
      this.$store.commit('deleteProvince')
      localStorage.clear()
      this.$router.replace({
        path:'/'
      })
    },
    showMenu(){
      this.isCollapse = !this.isCollapse
      this.$emit('showMenu',this.isCollapse)
    },
    goCenter(){
      this.$router.push({
        path:'/user/user'
      })
    }
  },
}
</script>

<style scoped lang="scss">
 @import '../assets/scss/header.scss';
</style>
